import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { get, post } from '../../utils/api'
import { IconBuilding, IconMapPin, IconUsers, IconArrowRight } from '@tabler/icons-react'

function fmt(v) { return '$' + Number(v || 0).toLocaleString('en-US', { minimumFractionDigits: 0 }) }

export default function CorporateHotels() {
  const { enterHotel } = useAuth()
  const navigate = useNavigate()
  const [hotels, setHotels] = useState([])
  const [regions, setRegions] = useState([])
  const [regionFilter, setRegionFilter] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    Promise.all([get('/corporate/hotels'), get('/corporate/regions')])
      .then(([h, r]) => { setHotels(h); setRegions(r) })
      .catch(console.error).finally(() => setLoading(false))
  }, [])

  const handleDrillIn = async (hotelId) => {
    try {
      const hotel = await post(`/corporate/drill-in/${hotelId}`)
      enterHotel(hotel)
      navigate('/corporate/hotel-view')
    } catch (err) { console.error(err) }
  }

  const filtered = regionFilter ? hotels.filter(h => String(h.region_id) === regionFilter) : hotels

  if (loading) return <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h2 className="mb-1">Hotels</h2>
          <div className="text-secondary">{hotels.length} properties in portfolio</div>
        </div>
        {regions.length > 1 && (
          <select className="form-select" style={{ width: 'auto' }} value={regionFilter} onChange={e => setRegionFilter(e.target.value)}>
            <option value="">All Regions</option>
            {regions.map(r => <option key={r.id} value={r.id}>{r.name} ({r.hotel_count})</option>)}
          </select>
        )}
      </div>

      <div className="row g-3">
        {filtered.map(h => (
          <div key={h.id} className="col-sm-6 col-lg-4">
            <div className="card h-100">
              <div className="card-body">
                <div className="d-flex align-items-start justify-content-between mb-3">
                  <div>
                    <h3 className="mb-1">{h.name}</h3>
                    <div className="text-secondary d-flex align-items-center gap-1">
                      <IconMapPin size={14} />{h.city}, {h.state}
                    </div>
                  </div>
                  {h.region_name && <span className="badge bg-blue-lt">{h.region_name}</span>}
                </div>
                <div className="row g-2 mb-3">
                  <div className="col-6">
                    <div className="text-secondary" style={{ fontSize: '0.7rem' }}>ROOMS</div>
                    <div className="fw-medium">{h.rooms || '--'}</div>
                  </div>
                  <div className="col-6">
                    <div className="text-secondary" style={{ fontSize: '0.7rem' }}>ACTIVE LEADS</div>
                    <div className="fw-medium">{h.active_leads}</div>
                  </div>
                  <div className="col-6">
                    <div className="text-secondary" style={{ fontSize: '0.7rem' }}>PIPELINE</div>
                    <div className="fw-medium">{fmt(h.pipeline)}</div>
                  </div>
                  <div className="col-6">
                    <div className="text-secondary" style={{ fontSize: '0.7rem' }}>YTD REVENUE</div>
                    <div className="fw-medium">{fmt(h.ytd_revenue)}</div>
                  </div>
                </div>
                <button className="btn btn-primary btn-sm w-100 d-flex align-items-center justify-content-center gap-1" onClick={() => handleDrillIn(h.id)}>
                  <IconArrowRight size={16} /> View Hotel CRM
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
